import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TimelineStateDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    iconBox: {
        justifyContent: "center",
        alignItems: "center"
    },
    container: {
        alignItems: "center",
        alignSelf: "center"
    },
    text: {
        textAlign: "center"
    }
});

export const useStyles = ({
    controlHeights,
    shapeConfigs,
    radiuses,
    colors,
    spaces
}: TimelineStateDynamicStyleType) => {
    const styles = {
        iconBox: {
            backgroundColor: colors.content.container.subtle,
            marginBottom: spaces.spacingSm,
            height: controlHeights.large,
            width: controlHeights.large,
            borderRadius: radiuses.full
        } as Mutable<ViewStyle>,
        container: {
            maxWidth: shapeConfigs.dialogMaxWidth,
            paddingVertical: spaces.spacingLg,
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        action: {
            paddingTop: spaces.spacingMd
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
